export default __webpack_public_path__ + "static/media/risingIcon.a8094f86.svg";